import { generateAPI } from "../api.generator";
import { Conversation } from "../../types/feedback";

// GET /feedback/mine/conversation — the customer's own support conversation.
export const getMyConversation = generateAPI<
  {},
  Conversation
>("get", "feedback/mine/conversation");
